import { Challenge } from '@wix/ambassador-challenges-v1-challenge/types';
import { isPrivateChallenge } from './isPrivateChallenge';

export const isAvailableForJoinImmediately = (challenge: Challenge): boolean =>
  !isPrivateChallenge(challenge);
